import { render, staticRenderFns } from "./TabBar.vue?vue&type=template&id=efaa0a40&scoped=true&"
import script from "./TabBar.vue?vue&type=script&lang=js&"
export * from "./TabBar.vue?vue&type=script&lang=js&"
import style0 from "./TabBar.vue?vue&type=style&index=0&id=efaa0a40&scoped=true&lang=less&"
import style1 from "./TabBar.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efaa0a40",
  null
  
)

export default component.exports